import React from 'react';
import { useTheme } from 'styled-components';

interface Props {
  size?: number;
  style?: React.CSSProperties;
}

/**
 * CRPD-7274 — the glyph that prefixes a control's name in the Maturity Score Table
 * (frame node 17987:2516): a rounded document with four rules, brand-gradient filled.
 *
 * Not `SheetsSvg`, which is the large multi-part spreadsheet illustration the Assessments empty
 * state draws — at 16px it collapses into noise.
 */
export const ControlSvg: React.FC<Props> = ({ size = 16, style }) => {
  const colors = useTheme().colors;
  // useId's own value contains colons, which are not valid inside a `url(#…)` reference.
  const id = `grad${React.useId().replace(/:/g, '')}`;

  return (
    <svg
      width={(size * 13.6) / 16}
      height={size}
      viewBox="0 0 13.6 16"
      fill="none"
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3999 0H2.2001C0.986241 0 0 0.986242 0 2.20011V13.7999C0 15.0134 0.986241 16 2.2001 16H11.3999C12.6134 16 13.6 15.0138 13.6 13.7999V2.20011C13.6 0.986242 12.6134 0 11.3999 0ZM9.71563 13.2002H3.71569C3.38456 13.2002 3.11569 12.9313 3.11569 12.6002C3.11569 12.2691 3.38456 12.0002 3.71569 12.0002H9.71563C10.0468 12.0002 10.3156 12.2691 10.3156 12.6002C10.3156 12.9313 10.0471 13.2002 9.71563 13.2002ZM9.71563 9.99994H3.71569C3.38456 9.99994 3.11569 9.73107 3.11569 9.39995C3.11569 9.06883 3.38456 8.79995 3.71569 8.79995H9.71563C10.0468 8.79995 10.3156 9.06883 10.3156 9.39995C10.3156 9.73107 10.0471 9.99994 9.71563 9.99994ZM9.71563 7.20022H3.71569C3.38456 7.20022 3.11569 6.93134 3.11569 6.60022C3.11569 6.2691 3.38456 6.00023 3.71569 6.00023H9.71563C10.0468 6.00023 10.3156 6.2691 10.3156 6.60022C10.3156 6.93134 10.0471 7.20022 9.71563 7.20022ZM9.71563 3.99999H3.71569C3.38456 3.99999 3.11569 3.73112 3.11569 3.4C3.11569 3.06887 3.38456 2.8 3.71569 2.8H9.71563C10.0468 2.8 10.3156 3.06887 10.3156 3.4C10.3156 3.73112 10.0471 3.99999 9.71563 3.99999Z"
        fill={`url(#${id})`}
      />
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="16.2893" y2="3.99944" gradientUnits="userSpaceOnUse">
          <stop offset="0.0001" stopColor={colors.gp1} />
          <stop offset="1" stopColor={colors.gp2} />
        </linearGradient>
      </defs>
    </svg>
  );
};
